module.exports = __webpack_public_path__ + "img/20190527162535051.5f40aaee.png";